import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export const useSSNavigate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const openAuth = () => {
    navigate('/auth', { replace: true });
  };

  const openInvalidLink = () => {
    navigate('/invalid-link', { replace: true });
  };

  const openPrepare = () => {
    navigate(`/prepare?${searchParams}`, { replace: true });
  };

  const openTest = () => {
    navigate(`/test?${searchParams}`, { replace: true });
  };

  const openResult = () => {
    navigate(`/result?${searchParams}`, { replace: true });
  };

  const closeWindow = (domainUrl?: string) => {
    window.location.replace(
      `${domainUrl || 'https://dashboard-web-2w5.pages.dev'}/test`,
    );
  };

  return {
    openAuth,
    openInvalidLink,
    openPrepare,
    openTest,
    openResult,
    closeWindow,
  };
};
